import {
    EventEmitter,
} from "fbemitter";

const VisualizerEmitter = new EventEmitter();
export default VisualizerEmitter;
